import React from 'react'
import PropTypes from 'prop-types'
import BlurCont from 'Layout/BlurCont'
import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'
import useBodyOverflowHidden from 'Hooks/useBodyOverflowHidden'
import SvgIcon from 'Components/SvgIcon'
import { checkIsArchive } from 'Utils'
import useDisableBackButton from 'Hooks/useDisableBackButton'
import useListingOpenLoginSignup from 'Hooks/useListingOpenLoginSignup'
import { MODE_LABEL_MAPPING } from 'Defaults/searchPage'
import { BuildingV2 } from 'Pages'

import {
  _TitleCountContainer,
  _CloseBtn,
  _ListingCards,
  _BuildingName,
  _MapListingPopup,
  _ForSale,
} from './styles'
import WithSpinner from '../WithSpinner'
import ListingList from './components/ListingList'

const GOOGLE_EVENT_CATEGORY = 'Map Listing Popup'

export const TEST_IDS = {
  BUILDING_APP_LINK: 'buildingAppLink',
  MARKER_ADDRESS: 'markerAddress',
}


// @todo only show shadow when it is not top
const MapListingPopup = (
  {
    winWidth,
    markerAddressData,
    isFetchingMarkerAddress,
    userIsAuthentificated,
    clearSelectedMarker,
    usePopupStyle = false,
    googleAnalyticsEvent,
    mode,
    isBc,
    isMobileApp,
  }) => {
  const addressData = markerAddressData
  const listingCount = addressData && addressData.listings ? addressData.listings.length : 0

  useDisableBackButton({
    enabled: listingCount > 0,
    onBackButtonPress: () => clearSelectedMarker(null),
  })

  useBodyOverflowHidden(listingCount > 1 && !usePopupStyle)
  if(isFetchingMarkerAddress) {
    return (
      <_MapListingPopup
        popupStyle={usePopupStyle}
        isBc={isBc}
        multiListings={listingCount > 1}
        multiListingMapPopup={listingCount > 1 && usePopupStyle}
      >
        <WithSpinner showSpinner />
      </_MapListingPopup>
    )
  }

  const {
    openLogin,
    openSignup,
  } = useListingOpenLoginSignup({
    sourcePage: 'SearchPage',
  })

  const loginHandler = ({ gate, termsConditionRequiredId, listing }) => {
    openLogin({
      gate,
      listing,
      termsConditionRequiredId,
    })
  }
  const signupHandler = ({ gate, termsConditionRequiredId, listing }) => {
    openSignup({
      gate,
      listing,
      termsConditionRequiredId,
    })
  }


  if(!listingCount) return null
  const building = addressData && addressData.building
  const isArchive = checkIsArchive(mode)
  const multiListings = listingCount > 1

  return (
    <_MapListingPopup
      popupStyle={usePopupStyle}
      isBc={isBc}
      multiListings={multiListings}
      multiListingMapPopup={listingCount > 1 && usePopupStyle}
      isMobileApp={isMobileApp}
    >
      <_CloseBtn onClick={() => clearSelectedMarker(null)} multiListings={multiListings}>
        <SvgIcon
          name={`#icon-${multiListings ? 'arrow-back' : 'slim-close'}`}
          width={multiListings ? 10 : 8}
          height={multiListings ? 23 : 8}
        />
      </_CloseBtn>
      <_TitleCountContainer align={'center'}>
        <BlurCont blur={isArchive && !userIsAuthentificated}>
          {
            building && building.url ? (
              <AppLinkMobileCtrl
                openNewTab
                data-test-id={'buildingAppLink'}
                alt={building.name}
                to={'/' + building.url}
                onClick={() => {
                  googleAnalyticsEvent({
                    category: GOOGLE_EVENT_CATEGORY,
                    action: '[Navigate to building]',
                  })
                }}
                lookupLinkData={{
                  component: 'Building',
                  id: building.id,
                  pageData: building,
                }}
                mobileModalChildren={
                  // eslint-disable-next-line react/no-unstable-nested-components
                  ({ closeModalPage }) => (
                    <BuildingV2
                      buildingId={building?.id}
                      modalBuildingData={building}
                      closeModalPage={closeModalPage}
                    />
                  )
                }
                mobileModalKey={`buildingModal-${building.id}`}
              >
                <_BuildingName>
                  {building.name}
                </_BuildingName>
              </AppLinkMobileCtrl>
            ) : (
              <_BuildingName data-test-id={'markerAddress'}>
                <span>{addressData.address}</span>
              </_BuildingName>
            )
          }
        </BlurCont>

        <_ForSale>
          {listingCount} {isArchive ? '' : 'For'} {MODE_LABEL_MAPPING[mode] || 'Sale'}
        </_ForSale>
      </_TitleCountContainer>
      <_ListingCards direction={'col'}>
        {
          listingCount ?
            <ListingList
              listings={addressData.listings}
              isBc={isBc}
              mode={mode}
              winWidth={winWidth}
              userIsAuthentificated={userIsAuthentificated}
              googleAnalyticsEvent={googleAnalyticsEvent}
              loginHandler={loginHandler}
              signupHandler={signupHandler}
              multiListings={multiListings}
            /> : null
        }
      </_ListingCards>
    </_MapListingPopup>
  )
}

MapListingPopup.propTypes = {
  winWidth: PropTypes.number,
  usePopupStyle: PropTypes.bool,
  markerAddressData: PropTypes.shape({}),
  userIsAuthentificated: PropTypes.bool,
  isBc: PropTypes.bool,
  mode: PropTypes.string,
  clearSelectedMarker: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  isFetchingMarkerAddress: PropTypes.bool,
  isMobileApp: PropTypes.bool,
}

export default MapListingPopup
